module.exports = __webpack_public_path__ + "static/media/divide.f63983ee.svg";